import React, { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { MoveButtonState } from "../../recoil/states";
import { asyncReqBoardInfo } from "../../reducers/BoardInfoReducer";
import { TopMainBtnsActions } from "../../reducers/TopMainBtnsReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";

export interface FcRef {
    handlerTopBtns: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, type: string) => void;
}

const TopMainBtns = forwardRef<FcRef>((props, ref) => {

    const setMoveButtonState = useSetRecoilState(MoveButtonState); // '순차 / 랜덤' 버튼 클릭 여부 정보를 갖는 state
    const dispatch = useDispatch<AppDispatch>();

    // 부모 컴포넌트에서 호출 가능한 함수 정의
    useImperativeHandle(ref, () => ({
        handlerTopBtns
    }));

    const btnOverClassName = useSelector((state: RootState) => state.TopMainBtnsReducer.btnOverClassName); // '커뮤니티 / 웃긴사진 / 사진편집' 메뉴 롤오버 처리를 위한 state

    // 루트 주소로 진입한 경우, 기본 '웃긴사진' URL로 변경
    if (window.location.pathname === "/") {
        (window as any).urlChange("/board_info?view_type=RANDOM");
    }

    /**
    * 상단 네비게이션 버튼 클릭 이벤트
    * 
    * @param e 이벤트 객체
    * @param type 호출 유형 (COMMUNITY / BOARD / IMAGE)
    * @returns 
    */
    const handlerTopBtns = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, type: string) => {
        dispatch(TopMainBtnsActions.setBtnOverClassName({ [type]: "gnb_1da over" }));

        // '웃긴사진' 버튼을 클릭한 경우, 컨텐츠 가져오기
        if (type === "BOARD") {
            // 실시간으로 실행하면 화면 이동 전이라, 쿼리스트링을 이전 값으로 가져와서 일정시간 이후에 실행

            // '순차' 버튼 클릭 알림
            setMoveButtonState(rawState => ({ ...rawState, isClickBtnOrder: false, isClickBtnRandom: true }));

            const view_type = "RANDOM";
            const board_seq = "";
            dispatch(asyncReqBoardInfo({ view_type, board_seq }));
        }
    }

    return (
        <ul className="gnb_1dul">
            <li className="gnb_1dli" style={{ zIndex: 99 }}>
                <Link to="/community_board_list" className={btnOverClassName.COMMUNITY} onClick={(e) => handlerTopBtns(e, "COMMUNITY")}>커뮤니티</Link>
            </li>
            <li className="gnb_1dli" style={{ zIndex: 99 }}>
                <Link to="/board_info?view_type=RANDOM" className={btnOverClassName.BOARD} onClick={(e) => handlerTopBtns(e, "BOARD")}>웃긴사진</Link>
            </li>
            <li className="gnb_1dli" style={{ zIndex: 99 }}>
                <Link to="/image_maker" className={btnOverClassName.IMAGE} onClick={(e) => handlerTopBtns(e, "IMAGE")}>사진편집</Link>
            </li>
        </ul>
    )
});

export default TopMainBtns;
